<template>
  <div>
    <van-nav-bar :right-text="edit ? '编辑' : ''" @click-right="edit = false" />

    <div class="profile">
      <van-form @submit="onSubmit" validate-first :show-error="false">
        <div class="bg">
          <!-- <div class="edit" @click="edit = false" v-if="edit"></div> -->
          <van-field
            name="uploader"
            label="头像"
            size="large"
            center
            label-align="right"
            :readonly="edit"
          >
            <template #input>
              <img
                src="@/assets/images/avatar.png"
                alt=""
                style="
                  width: 2.75rem;
                  height: 2.75rem;
                  border-radius: 50%;
                  object-fit: cover;
                "
                v-if="!formData.avatar"
                @click="avatarUpload"
              />
              <img
                :src="formData.avatar"
                v-else
                alt=""
                style="
                  width: 2.75rem;
                  height: 2.75rem;
                  border-radius: 50%;
                  object-fit: cover;
                "
                @click="previewImg(formData.avatar)"
              />
              <!-- <van-tag
              plain
              type="primary"
              style="margin-left: 1rem;"
              size="medium"
              @click="avatarUpload"
              v-if="formData.avatar && formData.personType !== 13"
              >更换</van-tag
            > -->
              <!-- v-if="formData.personType !== 13" -->

              <!-- <van-uploader
            v-model="curFileList"
            :after-read="afterReadCur"
            :before-delete="beforeDelCur"
            :deletable="formData.personType !== 13"
            :max-count="1"
            :disabled="formData.personType === 13"
          >
            <img
              src="@/assets/images/avatar.png"
              alt=""
              style="width: 2.75rem; height: 2.75rem;"
            />
          </van-uploader> -->
            </template>
          </van-field>
          <van-field
            label-align="right"
            v-model="formData.name"
            name="姓名"
            label="姓名"
            size="large"
            :readonly="true"
          />
          <van-field
            label-align="right"
            v-model="formData.mobile"
            name="手机号"
            label="手机号"
            size="large"
            placeholder="请输入手机号"
            :readonly="edit"
            :rules="
              !edit
                ? [
                    {
                      required: true,
                      message: '请填写手机号',
                      pattern: /^1[3456789]{1}\d{9}$/,
                    },
                  ]
                : []
            "
          />
          <!-- <van-field
            label-align="right"
            v-model="formData.deptName"
            name="单位名称"
            :label="formData.personType === 13 ? '部门名称' : '单位名称'"
            :placeholder="
              `请输入${formData.personType === 13 ? '部门名称' : '单位名称'}`
            "
            size="large"
            :readonly="edit && formData.personType === 13"
          />
          <van-field
            label-align="right"
            v-model="formData.idNumber"
            name="身份证号"
            label="身份证号"
            placeholder="请输入身份证号"
            size="large"
            :readonly="edit"
            :rules="rules.idcard"
          />
          <van-field
            label-align="right"
            v-model="formData.licensePlate"
            name="车牌号"
            label="车牌号"
            :readonly="edit"
            size="large"
            placeholder="请输入车牌号"
            :rules="rules.licencePlate"
          /> -->
        </div>
        <div style="margin-top: 1rem">
          <van-row :gutter="20">
            <!-- <van-col :span="12"> -->
            <!-- <van-button round block type="default" @click="$router.go(-1)">
            </van-button> -->
            <!-- <div class="back" @click="$router.go(-1)">
                返回
              </div>
            </van-col> -->
            <van-col :span="24">
              <van-button
                round
                block
                type="info"
                native-type="submit"
                :loading="btn_loading"
                :disabled="btn_loading"
                loading-text="保存中..."
                v-if="!edit"
              >
                提交
              </van-button>
            </van-col>
          </van-row>
        </div>
      </van-form>
    </div>
  </div>
</template>

<script>
// import { compressAccurately } from 'image-conversion'
import { upload } from "@/utils/upload";
import * as validate from "@/utils/validate";
import uploadImg from "@/utils/upload.service";
import assign from "@/mixins/assign";
import { ImagePreview } from "vant";

export default {
  mixins: [assign],

  data() {
    return {
      curFileList: [],
      formData: {
        avatar: null,
        mobile: null,
        name: null,
        idNumber: null,
        personType: null,
        guestCompany: null,
        licensePlate: null,
        deptName: null,
      },
      num: 1,
      lasttime: 0,
      btn_loading: false,
      edit: true,
      rules: {
        idcard: [
          {
            validator: (val) => (val ? validate.isIdCard(val) : ""),
            message: "请输入正确的身份证号",
          },
        ],
        licencePlate: [
          {
            validator: (val) => (val ? validate.isLicencePlate(val) : ""),
            message: "请输入正确的车牌号",
          },
        ],
      },
    };
  },
  created() {
    this.formData = {
      ...this.formData,
      ...(localStorage.getItem("userInfo") &&
      JSON.parse(localStorage.getItem("userInfo"))),
      loginId: JSON.parse(localStorage.getItem("userInfo")).loginId,
      loginSchoolId: JSON.parse(localStorage.getItem("userInfo")).loginSchoolId,
    };
    if (this.formData.avatar) {
      this.curFileList[0] = {
        url: this.formData.avatar,
      };
    }
  },
  methods: {
    previewImg(imgurl) {
      ImagePreview({
        images: [imgurl],
        closeOnPopstate: true,
      });
    },
    clickBack() {
      this.$router.go(-1);
    },
    clickEdit() {
      this.edit = false;
    },
    onSubmit(values) {
      if (this.btn_loading) return false;
      this.btn_loading = true;

      const personType = this.formData.personType;
      // if (this.formData.personType === 13) {
      //   // delete this.formData.avatar
      //   // delete this.formData.guestCompany
      // }
      // delete this.formData.personType
      let formData=JSON.parse(JSON.stringify(this.formData))
      delete formData.idNumber
      this.axios
        .post("student-consumer/api/user/updateTpdUser", formData)
        .then((res) => {
          if (res.code === 200) {
            if (res.data) {
              let info = JSON.parse(localStorage.getItem("userInfo"));

              localStorage.setItem(
                "userInfo",
                JSON.stringify({
                  ...info,
                  ...res.data,
                })
              );
            }
            this.edit = true;
            this.$toast("编辑成功");
            // this.$router.go(-1)
          } else {
            this.$toast(res.msg);
            this.btn_loading = false;
          }
        })
        .catch((err) => {
          console.log(err);
          this.btn_loading = false;
          this.$toast("服务器错误，请联系管理员");
        })
        .finally((_) => {
          this.btn_loading = false;
        });
    },
    async avatarUpload() {
      // if (!this.edit) {
      //   try {
      //     const imgUrl = await uploadImg();
      //     this.for;
      //     this.$set(this.formData, "avatar", imgUrl);
      //   } catch (error) {
      //     this.$set(this.formData, "avatar", "");
      //   }
      // }
    },

    // upload(file) {
    //   try {
    //     return new Promise(async (resolve) => {
    //       file.status = 'uploading'
    //       file.message = '上传中...'
    //       const res = await compressAccurately(file, 200)
    //       let fileObj = new File([res], file.name, {
    //         type: res.type,
    //       })
    //       let formData = new FormData()
    //       formData.append('file', fileObj)
    //       const { code, data, msg } = await this.$https.upload(formData)
    //       if (code !== 200) {
    //         file.status = 'failed'
    //         file.message = '上传失败'
    //         this.$toast(msg)
    //         return false
    //       }
    //       this.$toast('上传成功')
    //       file.status = 'done'
    //       file.message = '上传成功'
    //       const { realm, address } = data
    //       const imgUrl = realm + address
    //       resolve(imgUrl)
    //     })
    //   } catch (error) {
    //     this.$toast('上传错误，服务器异常')
    //   }
    // },
    async afterReadCur(file) {
      try {
        const imgUrl = await upload(file.file);
        this.formData.avatar = imgUrl;
      } catch (error) {
        this.curFileList = [];
        this.formData.avatar = "";
      }
    },
    beforeDelCur(item, obj) {
      this.curFileList.splice(obj.index, 1);
      this.formData.avatar = null;
    },
  },
};
</script>

<style lang="scss" scoped>
@function px2rem($px) {
  @return $px / 16px * 1rem;
}
.profile {
  margin: 0.65em;
  /* box-shadow: 0px 4px 16px rgba(69, 91, 99, 0.08);
  background: #fff; */
  border-radius: 0.3em;
  overflow: hidden;
  .bg {
    background: #fff;
    border-radius: 1rem;
    overflow: hidden;
    position: relative;
    .edit {
      position: absolute;
      right: 0.5rem;
      color: #1989fa;
      font-size: 0.3rem;
      z-index: 88;
      padding: 0.5rem;
    }
  }
}
.back {
  width: 100%;
  height: 44px;
  border: 1px solid #ebedf0;
  color: #323233;
  font-size: 14px;
  text-align: center;
  line-height: 44px;
}
</style>
